import React, {Component} from 'react';
// Custom Components
import HeaderOne from './components/common/headers/header-one';
import FooterOne from "./components/common/footers/footer-one";
import {connect} from "react-redux";
import {withTranslate} from "react-redux-multilingual";

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
        }

        this.load();
    }

    componentDidMount() {
        this.syncDocumentLang();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.locale !== this.props.locale) {
            this.syncDocumentLang();
        }
    }

    // Lets CSS (:lang) and screen readers know which script is on screen. "am" is the app's code for Armenian (ISO "hy").
    syncDocumentLang() {
        const {locale} = this.props;
        document.documentElement.lang = locale === 'am' ? 'hy' : (locale || 'en');
    }

    load = () => {
        fetch('/api/menu.json')
            .then((response) => response.json())
            .then((res) => {
                this.menu = this.updateMenu(res);
                this.setState({isLoading: false})
                document.querySelector(".loader-wrapper").style = "display: none";
            })
            .catch(reason => {
                console.log(reason)
            })
    };

    updateMenu(menu) {
        const {translate} = this.props;
        menu.forEach((item, i) => {
            item.name = translate(item.name);
            if (item.children !== []) {
                item.children.forEach(j => {
                    j.name = translate(j.name);
                })
            }
        });
        return menu
    }

    render() {


        return !this.state.isLoading && (
            <div className="opal-wrapper">
                <div id="page" className="site">
                    <HeaderOne menu={this.menu}/>
                    <main id="main" tabIndex="-1">
                        {this.props.children}
                    </main>
                    <FooterOne/>
                </div>
            </div>

        );
    }
}

const mapStateToProps = (state) => {
    return {
        locale: state.Intl.locale
    }
};

export default connect(mapStateToProps)(withTranslate(App));